import { render, staticRenderFns } from "./MchPayConfigAddOrEdit.vue?vue&type=template&id=6d1f37f0&scoped=true"
import script from "./MchPayConfigAddOrEdit.vue?vue&type=script&lang=js"
export * from "./MchPayConfigAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./MchPayConfigAddOrEdit.vue?vue&type=style&index=0&id=6d1f37f0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1f37f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1f37f0')) {
      api.createRecord('6d1f37f0', component.options)
    } else {
      api.reload('6d1f37f0', component.options)
    }
    module.hot.accept("./MchPayConfigAddOrEdit.vue?vue&type=template&id=6d1f37f0&scoped=true", function () {
      api.rerender('6d1f37f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mchApp/MchPayConfigAddOrEdit.vue"
export default component.exports